import { EFinancingOfferRoute } from '@/types'

export const FADING_ANIMATION_DURATION = 250
export const FROM_PROFILE_INDEX_PAGE_QUERY_PARAMETER = 'fromProfileIndexPage'
export const PROFILE_MFO_BANNER_MORE_DETAILS_LINK = `${EFinancingOfferRoute.MFOPage}?${FROM_PROFILE_INDEX_PAGE_QUERY_PARAMETER}=true`
